var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-visibility",
    d: "M20.873,10.968A11.694,11.694,0,0,0,10.5,4.5,11.7,11.7,0,0,0,.127,10.968a1.179,1.179,0,0,0,0,1.064A11.694,11.694,0,0,0,10.5,18.5a11.7,11.7,0,0,0,10.373-6.468A1.179,1.179,0,0,0,20.873,10.968ZM10.5,16.75a5.25,5.25,0,1,1,5.25-5.25A5.25,5.25,0,0,1,10.5,16.75ZM10.5,8a3.475,3.475,0,0,0-.923.138,1.745,1.745,0,0,1-2.439,2.439A3.492,3.492,0,1,0,10.5,8Z",
    transform: "translate(0 -4.5)",
    fill: "#9e9e9e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.367ed6bbdb5b6e1281620a52995d33b4.svg";
export { ForwardRef as ReactComponent };